import React from 'react'
import ForgotPassward from './ForgotPassward'

export default function index() {
  return (
    <>
    <ForgotPassward/>
    </>
  )
}
